export default "__VITE_ASSET__DiQcZ9y7__"